import React, { useState } from "react";
import {
    OutlinedInput,
    InputAdornment,
    IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";


export default function ParticipantsSearchBar({
    value,
    onChange,
    onSearch,
    placeholder = "Search"
}) {

    const inputValue = value || "";

    const handleChange = (event) => {
      onChange?.(event.target.value);
    };

    const handleSearch = () => {
        onSearch?.(inputValue);
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleSearch();
        }
    };

  const handleClear = () => {
    onChange?.("");
    onSearch?.("");
  };

    return ( <>
        <OutlinedInput
            fullWidth
            value={inputValue}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            placeholder={placeholder}
            endAdornment={
                <InputAdornment position="end">
                    {inputValue && (
                        <IconButton
                            onClick={handleClear}
                            edge="end"
                        >
                            <ClearIcon />
                        </IconButton>

                    )}
                    <IconButton onClick={handleSearch} edge="end" >
                        <SearchIcon />
                    </IconButton>
                </InputAdornment>
            }
        />

</> );
}